import React, { useState, useEffect } from "react";
import { graphql, useStaticQuery } from "gatsby";
import AceleradoraCard from "../../molecules/aceleradora-card/aceleradoraCard";
import useBrowserMode from '../../../shared/hooks/useBrowserMode';

// Components
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";

//Styles
import "./FormAceleradora.scss";

const FormAceleradora = (props: any) =>{
    
    const data = useStaticQuery(graphql`
        query contentfulFormAceleradora {
            form: allContentfulContactenos(
                filter: { contentful_id: { eq: "3FxPFtnvXjT94OvAzyX3hd" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    tituloFormulario
                    titulosFormulario {
                        tituloGeneral
                        descripcion {
                            raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            obligatorio
                            seccion
                            tabOrder
                            ayuda
                            placeholder
                        }
                        tituloBoton
                    }
                    imagenesEmpleo {
                        file {
                            url
                            details {
                                image {
                                    height
                                    width
                                }
                            }
                        }
                    }
                    imagenFormulario {
                        file {
                            details {
                                image {
                                    width
                                    height
                                }
                            }
                            url
                        }
                    }
                    imagenWizardCentroEmpleo {
                        file {
                            url
                        }
                    }
                    tituloUbicacion
                    redireccionBoton
                }
            }
            modalSuccess: allContentfulContactenos(
                filter: { contentful_id: { eq: "2wVQxyji239YkMVOo2xP30" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
            modalRegistered: allContentfulContactenos(
                filter: { contentful_id: { eq: "4vq4fwLSOyRffREJQSDCHZ" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    tituloBotonOpcional
                    redireccionBotonOpcional
                    contentful_id
                }
            }
            modalRecuerda: allContentfulContactenos(
                filter: { contentful_id: { eq: "12SG8Cp6ykybweOmxeHPgX" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    contentful_id
                }
            }
            modalCancelar: allContentfulContactenos(
                filter: { contentful_id: { eq: "161Y9ILG8uX5iRpulhseIs" } }
            ) {
                nodes {
                    tituloPrincipal
                    tituloBoton
                    redireccionBoton
                    tituloBotonOpcional
                    redireccionBotonOpcional
                    contentful_id
                }
            }
            modalDeshabilitar: allContentfulContactenos(
                filter: { contentful_id: { eq: "13weMo2Nf1LgerLFav6kLv" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcion {
                        raw
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                    formularioCeidActivo
                    fechaInicioConvocatoria
                    fechaFinConvocatoria
                }
            }
            modalEdad: allContentfulContactenos(
                filter: { contentful_id: { eq: "28EVIYyLuqE5OjfSUVFLaj" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario{
                        raw
                    }
                    edadPermitida
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                    formularioMigrantesActivo
                }
            }
        }
    `);
    
    const contentfulData = data.form.nodes[0];
    const contentfulModalSuccess = data.modalSuccess.nodes[0];
    const contentfulModalRegistered = data.modalRegistered.nodes[0];
    const contentfulModalRecuerda = data.modalRecuerda.nodes[0];
    const contentfulModalCancelar = data.modalCancelar.nodes[0];
    const contentfulModalDeshabilitar = data.modalDeshabilitar.nodes[0];
    const contentfulModalEdad = data.modalEdad.nodes[0];
    
    const { isBrowser, window } = useBrowserMode();
    const [pathname, setPathname] = useState("");

    useEffect(() => {
        const getPathname = () => {
            if(isBrowser) {
                if (window.location.pathname.includes("personas")) {
                    setPathname("Personas")
                }
            }
        }

        getPathname();
    }, [])

    return (
        <>
            <div className="m-form-aceleradora">
                <div className="m-breadcrumb">
                    <Breadcrumb content={ `Inicio / ${pathname} / ${contentfulData.tituloPrincipal}` } />
                </div>
                <>
                    <AceleradoraCard 
                        tituloPrincipal={contentfulData.tituloPrincipal}
                        tituloFormulario={contentfulData.tituloFormulario}
                        descripcionFormulario={
                            JSON.parse(contentfulData.descripcionFormulario.raw)
                        }
                        tituloUbicacion={contentfulData.tituloUbicacion}
                        titulosFormulario={contentfulData.titulosFormulario}
                        metaTitulo={contentfulData.metaTitulo}
                        imagenWizard={contentfulData.imagenWizardCentroEmpleo.file.url}
                        modalSuccess={contentfulModalSuccess}
                        modalRegistered={contentfulModalRegistered}
                        modalRecuerda={contentfulModalRecuerda}
                        modalCancelar={contentfulModalCancelar}
                        modalDeshabilitar={contentfulModalDeshabilitar}
                        pathSharepoint={contentfulData.redireccionBoton}
                        modalEdad={contentfulModalEdad}
                    />
                </>
            </div>
        </>
    );
};

export default FormAceleradora;